import { render, staticRenderFns } from "./SoundToggle.vue?vue&type=template&id=d5e42a10&"
import script from "./SoundToggle.vue?vue&type=script&lang=js&"
export * from "./SoundToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports